import Enter from '@/generic/Enter/Enter';

const EnterChunk = (chunks: never) => <Enter>{chunks}</Enter>;

export default EnterChunk;
